import useI18nTl from '@/hooks/useI18nTl'

import {
  EvseChargingSpeedType,
  EssGridType,
  StationConstruction,
  StationType,
  Country,
  FieldEnable,
  EvseState,
  ConnectorState,
  EvseOperationType,
  UseVehicleType,
  EvseCurrentType,
  EvseNetworkingMode,
  EvseStandard,
  EvsePhase,
  EvseConnectorType,
  KWHTariffTag,
  IdType,
  TicketState,
  Language,
  ADOType,
  StatisticsTimeGrain,
  ChargingScheduleAlgorithm,
  Currency,
  NotiChannel,
  PaymentChannel,
  ActivityType,
  EvseProtocolVendor,
  AlarmLevelType,
  AlarmType,
  TerminalChannel,
  TerminalHomeShowType,
  EvseFunction,
  BankCardType,
  ProfitSharingAccountType,
  ProfitSharingSource,
  StationTag,
  PaymentModeType,
  BarrierGateCouponType,
  ProfitSharingTransactionType,
  ProfitSharingTradeState,
  AuditState,
  TransactionState,
  OrderState,
  TransactionType,
  PaymentMethod,
  PaymentMode,
  SMSProvider,
  HLHTProtocol,
  StationState,
  GroupType,
  PricingDescountInfoType,
  CommonState,
  InvoiceTitleType,
  BusinessState,
  BarrierGateType,
  EssDeviceType,
  RescueOrderState,
  RescueType,
  CooperState,
  CooperType,
} from '@/types/types'

type enumKeyValueNumberList = Array<{ value: number; label: string }>
import { DefaultRoleType } from '@/types/common/system'
export default (): {
  essGridType: enumKeyValueNumberList
  essDeviceType: enumKeyValueNumberList
  enableSelects: enumKeyValueNumberList
  evseStateSelects: enumKeyValueNumberList
  connectorStateSelects: enumKeyValueNumberList
  evseOperationTypes: enumKeyValueNumberList
  useVehicleTypes: enumKeyValueNumberList
  evseCurrentTypes: enumKeyValueNumberList
  evseNetworkingModes: enumKeyValueNumberList
  evseStandards: enumKeyValueNumberList
  evsePhases: enumKeyValueNumberList
  connectorTypes: enumKeyValueNumberList
  evseChargingSpeedType: enumKeyValueNumberList
  evseFuncs: enumKeyValueNumberList
  timeRanges: enumKeyValueNumberList
  stationType: enumKeyValueNumberList
  getStationType: (at: number) => string
  country: enumKeyValueNumberList
  getCountry: (s: Country) => string | null
  stationConstruction: enumKeyValueNumberList
  StationStates: enumKeyValueNumberList
  currency: enumKeyValueNumberList
  defaultRoleTypes: enumKeyValueNumberList
  getCurrency: (s: Currency) => string | null
  currencySymbol: enumKeyValueNumberList
  getCurrencySymbol: (s: Currency) => string
  priceingTags: enumKeyValueNumberList
  getPriceingTagsDesc: (s: number) => string | null
  timeSelect: enumKeyValueNumberList
  cardTypes: enumKeyValueNumberList
  ticketStates: enumKeyValueNumberList
  languages: enumKeyValueNumberList
  langOptions: Array<{ value: string; label: string }>
  grainOptions: enumKeyValueNumberList
  chargingScheduleAlgorithms: enumKeyValueNumberList
  chargingProfilePurposes: Array<{ value: string; label: string }>
  chargingProfileKinds: Array<{ value: string; label: string }>
  recurrencyKinds: Array<{ value: string; label: string }>
  getChargingScheduleDesc: (s: number) => string | null
  getAdoType: (at: ADOType) => string | null
  adoTypes: enumKeyValueNumberList
  getAdoTypeDesc: (at: number) => string
  getAdoTypeArray: (ats: number[]) => enumKeyValueNumberList
  notiChannels: enumKeyValueNumberList
  getNotiChannelDesc: (at: NotiChannel) => string | null
  paymentChannels: enumKeyValueNumberList
  getPaymentChannelDesc: (at: PaymentChannel) => string
  terminnalChannels: enumKeyValueNumberList
  getTerminnalChannelDesc: (at: TerminalChannel) => string
  activityTypes: enumKeyValueNumberList
  getActivityTypeDesc: (at: number) => string
  evseProtocols: enumKeyValueNumberList
  getEvseProtocolDesc: (at: number) => string
  alarmTypes: enumKeyValueNumberList
  getAlarmTypeDesc: (at: number) => string
  alarmLevels: enumKeyValueNumberList
  getAlarmLevelDesc: (at: number) => string
  terminalHomeShowTypes: enumKeyValueNumberList
  getTerminalHomeShowTypeDesc: (at: number) => string
  payeeTypes: enumKeyValueNumberList
  getPayeeTypeDesc: (at: number) => string
  bankCardTypes: enumKeyValueNumberList
  getBankCardTypeDesc: (at: number) => string
  profitSharingSources: enumKeyValueNumberList
  getProfitSharingSourceDesc: (at: number) => string
  stationTags: enumKeyValueNumberList
  getStationTagDesc: (at: number) => string
  paymentModeTypes: enumKeyValueNumberList
  getPaymentModeTypeDesc: (at: number) => string
  barrierGateCouponTypes: enumKeyValueNumberList
  getBarrierGateCouponTypeDesc: (at: number) => string
  profitSharingTransactionTypes: enumKeyValueNumberList
  getProfitSharingTransactionTypeDesc: (at: number) => string
  profitSharingTradeStates: enumKeyValueNumberList
  getProfitSharingTradeStateDesc: (at: number) => string
  auditStates: enumKeyValueNumberList
  getAuditStateDesc: (at: number) => string
  transactionStates: enumKeyValueNumberList
  getTransactionStateDesc: (at: number) => string
  orderStates: enumKeyValueNumberList
  getOrderStateDesc: (at: number) => string
  transactionTypes: enumKeyValueNumberList
  getTransactionTypeDesc: (at: number) => string
  paymentMethods: enumKeyValueNumberList
  getPaymentMethodDesc: (at: number) => string
  paymentModes: enumKeyValueNumberList
  getPaymentModeDesc: (at: number) => string
  SMSProviders: enumKeyValueNumberList
  getSMSProviderDesc: (at: number) => string
  HLHTProtocols: enumKeyValueNumberList
  getHLHTProtocolDesc: (at: number) => string
  GroupTypes: enumKeyValueNumberList
  getGroupTypeDesc: (at: number) => string
  PricingDescountInfoTypes: enumKeyValueNumberList
  getPricingDescountInfoTypeDesc: (at: number) => string

  commonStates: enumKeyValueNumberList
  getCommonStateDesc: (at: number) => string

  invoiceTitleTypes: enumKeyValueNumberList
  getInvoiceTitleTypeDesc: (at: number) => string
  BusinessStatesTypes: enumKeyValueNumberList
  getBusinessStatesTypeDesc: (at: number) => string

  BarrierGateTypes: enumKeyValueNumberList
  getBarrierGateTypeDesc: (at: number) => string

  rescueOrderState: enumKeyValueNumberList
  GetRescueOrderStateDesc: (at: number) => string

  rescueType: enumKeyValueNumberList
  GetRescueTypeDesc: (at: number) => string

  CooperStates: enumKeyValueNumberList
  GetCooperStateDesc: (at: number) => string

  CooperTypes: enumKeyValueNumberList
  GetCooperTypeDesc: (at: number) => string
} => {
  const { t, tl } = useI18nTl('Base')
  const defaultRoleTypes = [
    {
      value: DefaultRoleType.DRT_ADMIN,
      label: t('Operation.drtAdmin'),
    },
    {
      value: DefaultRoleType.DRT_AGENT_OPERATOR,
      label: t('Operation.drtAgentOperator'),
    },
    {
      value: DefaultRoleType.DRT_AGENT_OPERATOR_VIEW,
      label: t('Operation.drtAgentOperatorView'),
    },
    {
      value: DefaultRoleType.DRT_BRAND_OPERATOR,
      label: t('Operation.drtBrandOperator'),
    },
    {
      value: DefaultRoleType.DRT_BRAND_OPERATOR_VIEW,
      label: t('Operation.drtBrandOperatorView'),
    },
    {
      value: DefaultRoleType.DRT_FINANCE,
      label: t('Operation.drtFinance'),
    },
    {
      value: DefaultRoleType.DRT_OPS,
      label: t('Operation.drtOps'),
    },
    {
      value: DefaultRoleType.DRT_PROFIT_SHARING_PAYEE,
      label: t('Operation.drtProfitSharingPayee'),
    },
    {
      value: DefaultRoleType.DRT_STATION,
      label: t('Operation.drtStation'),
    },
    {
      value: DefaultRoleType.DRT_STATION_VIEW,
      label: t('Operation.drtStationView'),
    },
  ]
  const BusinessStatesTypes = [
    // { value: BusinessState.BS_INIT, label: t('Operation.businessStateInit') },
    { value: BusinessState.BS_OPEN_BUSINESS, label: t('Operation.businessStateOpenBusiness') },
    {
      value: BusinessState.BS_SUSPEND_BUSINESS,
      label: t('Operation.businessStateSuspendBusiness'),
    },
    { value: BusinessState.BS_CLOSED_BUSINESS, label: t('Operation.businessStateClosedBusiness') },
    {
      value: BusinessState.BS_INTERNAL_BUSINESS,
      label: t('Operation.businessStateInternalBusiness'),
    },
  ]

  const getBusinessStatesTypeDesc = (at: number): string => {
    for (let i = 0; i < BusinessStatesTypes.length; i++) {
      if (BusinessStatesTypes[i].value === at) {
        return BusinessStatesTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const BarrierGateTypes = [
    { value: BarrierGateType.BGT_UNKNOWN, label: t('Base.select') },
    { value: BarrierGateType.BGT_JS, label: t('Operation.bgtJs') },
    { value: BarrierGateType.BGT_LTY, label: t('Operation.bgtLty') },
  ]

  const getBarrierGateTypeDesc = (at: number): string => {
    for (let i = 0; i < BarrierGateTypes.length; i++) {
      if (BarrierGateTypes[i].value === at) {
        return BarrierGateTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const invoiceTitleTypes = [
    { value: InvoiceTitleType.ITT_PERSON, label: t('Base.person') },
    { value: InvoiceTitleType.ITT_COMPANY, label: t('Base.company') },
  ]

  const getInvoiceTitleTypeDesc = (at: InvoiceTitleType): string => {
    for (let i = 0; i < invoiceTitleTypes.length; i++) {
      if (invoiceTitleTypes[i].value === at) {
        return invoiceTitleTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const evseChargingSpeedType = [
    { value: EvseChargingSpeedType.ECS_FAST, label: t('Evses.ECS_FAST') },
    { value: EvseChargingSpeedType.ECS_SLOW, label: t('Evses.ECS_SLOW') },
  ]

  const commonStates = [
    { value: CommonState.CMS_PENDING, label: t('Base.commonStatePending') },
    { value: CommonState.CMS_PROCESS, label: t('Base.commonStateProcess') },
    { value: CommonState.CMS_FAIL, label: t('Base.commonStateFail') },
    { value: CommonState.CMS_PROCESSED, label: t('Base.commonStateProcessed') },
    { value: CommonState.CMS_CLOSE, label: t('Base.commonStateClose') },
  ]

  const getCommonStateDesc = (at: CommonState): string => {
    for (let i = 0; i < commonStates.length; i++) {
      if (commonStates[i].value === at) {
        return commonStates[i].label
      }
    }
    return t('Base.unknown')
  }

  const essGridType = [
    /** EGT_Unknown - 未知并网方式 */
    { value: EssGridType.EGT_Unknown, label: t('EssDevice.EGT_Unknown') },
    /** EGT_FeedbackAll - 全额馈网 */
    { value: EssGridType.EGT_FeedbackAll, label: t('EssDevice.EGT_FeedbackAll') },
    /** EGT_SelfSufficiency - 自发自用(部分馈网) */
    { value: EssGridType.EGT_SelfSufficiency, label: t('EssDevice.EGT_SelfSufficiency') },
    /** EGT_NoFeedback - 无馈网 */
    { value: EssGridType.EGT_NoFeedback, label: t('EssDevice.EGT_NoFeedback') },
    /** EGT_OffGrid - 离网 */
    { value: EssGridType.EGT_OffGrid, label: t('EssDevice.EGT_OffGrid') },
  ]

  const essDeviceType = [
    // 光伏逆变器
    { value: EssDeviceType.EDT_PV, label: t('EssDevice.EDT_PV') },
    // 储能逆变器(电池储能)
    { value: EssDeviceType.EDT_ES, label: t('EssDevice.EDT_ES') },
    // 混合逆变器(光储一体化)
    { value: EssDeviceType.EDT_HYBRID, label: t('EssDevice.EDT_HYBRID') },
    // 微电网逆变器
    { value: EssDeviceType.EDT_MICRO, label: t('EssDevice.EDT_MICRO') },
    // 并网逆变器
    { value: EssDeviceType.EDT_GRID, label: t('EssDevice.EDT_GRID') },
    // 离网逆变器
    { value: EssDeviceType.EDT_OFFGRID, label: t('EssDevice.EDT_OFFGRID') },
  ]
  const PricingDescountInfoTypes = [
    /** PDIT_RATIO - 按比例计算 */
    { value: PricingDescountInfoType.PDIT_RATIO, label: t('Operation.PDIT_RATIO') },
    /** PDIT_FIXED - 按固定金额计算 */
    { value: PricingDescountInfoType.PDIT_FIXED, label: t('Operation.PDIT_FIXED') },
  ]

  const getPricingDescountInfoTypeDesc = (at: PricingDescountInfoType): string => {
    for (let i = 0; i < PricingDescountInfoTypes.length; i++) {
      if (PricingDescountInfoTypes[i].value === at) {
        return PricingDescountInfoTypes[i].label
      }
    }
    return t('Base.unknown')
  }
  const GroupTypes = [
    { value: GroupType.GT_Enterprise, label: t('Operation.GT_Enterprise') },
    { value: GroupType.GT_Pricing, label: t('Operation.GT_Pricing') },
  ]
  const getGroupTypeDesc = (at: GroupType): string => {
    for (let i = 0; i < GroupTypes.length; i++) {
      if (GroupTypes[i].value === at) {
        return GroupTypes[i].label
      }
    }
    return t('Base.unknown')
  }
  const enableSelects = [
    { value: FieldEnable.CES_ENABLE, label: tl('enable') },
    { value: FieldEnable.CES_DISABLE, label: tl('disable') },
  ]
  const evseStateSelects = [
    { value: EvseState.ES_OFFLINE, label: t('Evses.stateOffline') },
    { value: EvseState.ES_ONLINE, label: t('Evses.stateOnline') },
    { value: EvseState.ES_EXCEPTION, label: t('Evses.stateException') },
    { value: EvseState.ES_NONACTIVATED, label: t('Evses.stateNonactivated') },
  ]
  const connectorStateSelects = [
    { value: ConnectorState.CS_Unavailable, label: t('Evses.connectorStateUnavailable') },
    { value: ConnectorState.CS_Available, label: t('Evses.connectorStateAvailable') },
    { value: ConnectorState.CS_Preparing, label: t('Evses.connectorStatePreparing') },
    { value: ConnectorState.CS_Charging, label: t('Evses.connectorStateCharging') },
    { value: ConnectorState.CS_SuspendedEVSE, label: t('Evses.connectorStateSuspendedEVSE') },
    { value: ConnectorState.CS_SuspendedEV, label: t('Evses.connectorStateSuspendedEV') },
    { value: ConnectorState.CS_Finishing, label: t('Evses.connectorStateFinishing') },
    { value: ConnectorState.CS_Reserved, label: t('Evses.connectorStateReserved') },
    { value: ConnectorState.CS_Faulted, label: t('Evses.connectorStateFaulted') },
    { value: ConnectorState.CS_Waiting, label: t('Evses.connectorWaiting') },
    { value: ConnectorState.CS_Occupied, label: t('Evses.connectorOccupied') },
  ]
  const evseOperationTypes = [
    { value: EvseOperationType.EOT_HOME, label: t('Evses.evseOperationTypeHome') },
    { value: EvseOperationType.EOT_OPERATOR, label: t('Evses.evseOperationTypeOperator') },
  ]
  const useVehicleTypes = [
    { value: UseVehicleType.UVT_CART, label: t('Evses.cart') },
    { value: UseVehicleType.UVT_BIKE, label: t('Evses.bike') },
  ]
  const evseCurrentTypes = [
    { value: EvseCurrentType.ECT_AC, label: t('Evses.ac') },
    { value: EvseCurrentType.ECT_DC, label: t('Evses.dc') },
    { value: EvseCurrentType.ECT_AC_DC, label: t('Evses.acdc') },
  ]
  const evseNetworkingModes = [
    { value: EvseNetworkingMode.ENM_WIFI, label: 'WIFI' },
    { value: EvseNetworkingMode.ENM_4G, label: '4G' },
    { value: EvseNetworkingMode.ENM_LAN, label: 'WLAN' },
    { value: EvseNetworkingMode.ENET_2_4G, label: '2.4G' },
    { value: EvseNetworkingMode.ENET_5G, label: '5G' },
  ]
  const evseStandards = [
    { value: EvseStandard.ES_CHINESE, label: t('Evses.chineseStandard') },
    { value: EvseStandard.ES_AMERICAN, label: t('Evses.americanStandard') },
    { value: EvseStandard.ES_EUROPEAN, label: t('Evses.europeanStandard') },
  ]
  const evsePhases = [
    { value: EvsePhase.EP_ONE, label: t('Evses.onePhase') },
    { value: EvsePhase.EP_THREE, label: t('Evses.threePhase') },
  ]
  const connectorTypes = [
    { value: EvseConnectorType.ECT_AC_GBT, label: t('Evses.connectorTypeAcGbt') },
    { value: EvseConnectorType.ECT_AC_TYPE1, label: t('Evses.connectorTypeAcType1') },
    { value: EvseConnectorType.ECT_AC_TYPE2, label: t('Evses.connectorTypeAcType2') },
    { value: EvseConnectorType.ECT_AC_TYPE1_TINY, label: t('Evses.connectorTypeAcType1Tiny') },
    { value: EvseConnectorType.ECT_AC_NACS, label: t('Evses.connectorTypeAcNacs') },
    { value: EvseConnectorType.ECT_DC_GBT, label: t('Evses.connectorTypeDcGbt') },
    { value: EvseConnectorType.ECT_DC_CCS1, label: t('Evses.connectorTypeDcCcs1') },
    { value: EvseConnectorType.ECT_DC_CCS2, label: t('Evses.connectorTypeDcCcs2') },
    { value: EvseConnectorType.ECT_DC_CHM, label: t('Evses.connectorTypeDcChm') },
    { value: EvseConnectorType.ECT_DC_NACS, label: t('Evses.connectorTypeDcNacs') },
    { value: EvseConnectorType.ECT_BIKE, label: t('Evses.connectorTypeBike') },
  ]
  const evseFuncs = [
    { value: EvseFunction.EF_SectionPirce, label: t('Evses.funcSectionPirce') }, // 支持分段计费
    { value: EvseFunction.EF_ScheduleCharge, label: t('Evses.funcScheduleCharge') }, // 定时充电
    { value: EvseFunction.EF_GetTariff, label: t('Evses.funcGetTariff') }, // 获取计费模版
    { value: EvseFunction.EF_ElecThreeDecimals, label: t('Evses.funcElecThreeDecimals') }, // 3位小数计费
    { value: EvseFunction.EF_ReserverCharge, label: t('Evses.funcReserverCharge') }, // 预约充电
    { value: EvseFunction.EF_OfflineCharge, label: t('Evses.funcOfflineCharge') }, // 断网充电
    { value: EvseFunction.EF_SyncAli_0, label: t('Evses.funcSyncAli0') }, // 需要同步阿里云
    { value: EvseFunction.EF_SyncAli_1, label: t('Evses.funcSyncAli1') }, // 需要同步阿里云
    { value: EvseFunction.EF_BT, label: t('Evses.funcBT') }, // 蓝牙
    { value: EvseFunction.EF_BT_NO_SENSE, label: t('Evses.funcBtNoSense') }, // 无感蓝牙
  ]
  const StationStates = [
    { value: StationState.SS_IN_CONSTRUCTION, label: t('Operation.stationStateInConstruction') },
    { value: StationState.SS_CLOSE, label: t('Operation.stationStateClose') },
    { value: StationState.SS_MAINTAINED, label: t('Operation.stationStateMaintained') },
    { value: StationState.SS_OPERATION, label: t('Operation.stationStateOperation') },
  ]
  const timeRanges = [
    { value: 1, label: t('Base.timeLastDay') },
    { value: 2, label: t('Base.timeLastWeek') },
    { value: 3, label: t('Base.timeLastMonth') },
    { value: 4, label: t('Base.timeLastYear') },
  ]
  const country = [
    { value: Country.CY_CHINA, label: t('Operation.countryChina') },
    { value: Country.CY_US, label: t('Operation.countryUs') },
    { value: Country.CY_UK, label: t('Operation.countryUk') },
    { value: Country.CY_SINGAPORE, label: t('Operation.countrySingapore') },
    { value: Country.CY_NZ, label: t('Operation.countryNz') },
    { value: Country.CY_GERMANY, label: t('Operation.countryGermany') },
    { value: Country.CY_AUSTRALIA, label: t('Operation.countryAustralia') },
    { value: Country.CY_FRANCE, label: t('Operation.countryFrance') },
    { value: Country.CY_INDIA, label: t('Operation.countryIndia') },
    { value: Country.CY_JAPAN, label: t('Operation.countryJapan') },
  ]
  const getCountry = (at: Country): string => {
    for (let i = 0; i < country.length; i++) {
      if (country[i].value === at) {
        return country[i].label
      }
    }
    return t('Base.unknown')
  }
  const stationConstruction = [
    {
      value: StationConstruction.SC_HousingEstate,
      label: t('Operation.stationConstructionHousingEstate'),
    },
    {
      value: StationConstruction.SC_PublicInstitution,
      label: t('Operation.stationConstructionPublicInstitution'),
    },
    {
      value: StationConstruction.SC_Enterprises,
      label: t('Operation.stationConstructionEnterprises'),
    },
    {
      value: StationConstruction.SC_OfficeBuilding,
      label: t('Operation.stationConstructionOfficeBuilding'),
    },
    {
      value: StationConstruction.SC_IndustrialZone,
      label: t('Operation.stationConstructionIndustrialZone'),
    },
    {
      value: StationConstruction.SC_TransportationHub,
      label: t('Operation.stationConstructionTransportationHub'),
    },
    {
      value: StationConstruction.SC_RSFacilities,
      label: t('Operation.stationConstructionRSFacilities'),
    },
    { value: StationConstruction.SC_UGSpace, label: t('Operation.stationConstructionUGSpace') },
    {
      value: StationConstruction.SC_ParkingArea,
      label: t('Operation.stationConstructionParkingArea'),
    },
    {
      value: StationConstruction.SC_RoadsideParking,
      label: t('Operation.stationConstructionRoadsideParking'),
    },
    {
      value: StationConstruction.SC_HSServiceArea,
      label: t('Operation.stationConstructionHSServiceArea'),
    },
    {
      value: StationConstruction.SC_ScenicArea,
      label: t('Operation.stationConstructionScenicArea'),
    },
    {
      value: StationConstruction.SC_BusStation,
      label: t('Operation.stationConstructionBusStation'),
    },
    {
      value: StationConstruction.SC_OilGasStation,
      label: t('Operation.stationConstructionOilGasStation'),
    },
    { value: StationConstruction.SC_Taxi, label: t('Operation.stationConstructionTaxi') },
    { value: StationConstruction.SC_Other, label: t('Operation.stationConstructionOther') },
  ]
  const stationType = [
    { value: StationType.ST_PUBLIC, label: t('Operation.stationTypePublic') },
    { value: StationType.ST_PRIVATE, label: t('Operation.stationTypePrivate') },
    { value: StationType.ST_BUS_ONLY, label: t('Operation.stationTypeBusOnly') },
    { value: StationType.ST_SANITATION_ONLY, label: t('Operation.stationTypeSanitationOnly') },
    { value: StationType.ST_LOGISTICS_ONLY, label: t('Operation.stationTypeLogisticsOnly') },
    { value: StationType.ST_TIXI_ONLY, label: t('Operation.stationTypeTaxiOnly') },
    { value: StationType.ST_DUMP_TRUCK_ONLY, label: t('Operation.stationTypeDumpTruckOnly') },
    { value: StationType.ST_OTHER, label: t('Operation.stationTypeOther') },
  ]
  const getStationType = (at: StationType): string => {
    for (let i = 0; i < stationType.length; i++) {
      if (stationType[i].value === at) {
        return stationType[i].label
      }
    }
    return t('Base.unknown')
  }
  const currency = [
    { value: Currency.CU_CNY, label: 'CNY' },
    { value: Currency.CU_USD, label: 'USD' },
    { value: Currency.CU_EUR, label: 'EUR' },
    { value: Currency.CU_JPY, label: 'JPY' },
    { value: Currency.CU_KRW, label: 'KRW' },
    { value: Currency.CU_TWD, label: 'TWD' },
    { value: Currency.CU_HKD, label: 'HKD' },
    { value: Currency.CU_SGD, label: 'SGD' },
    { value: Currency.CU_AUD, label: 'AUD' },
    { value: Currency.CU_GBP, label: 'GBP' },
  ]
  const currencySymbol = [
    { value: Currency.CU_CNY, label: '¥' },
    { value: Currency.CU_USD, label: '$' },
    { value: Currency.CU_EUR, label: '€' },
    { value: Currency.CU_JPY, label: 'JPY¥' },
    { value: Currency.CU_KRW, label: '₩' },
    { value: Currency.CU_TWD, label: 'NT$' },
    { value: Currency.CU_HKD, label: 'HK$' },
    { value: Currency.CU_SGD, label: 'S$' },
    { value: Currency.CU_AUD, label: 'AU$' },
    { value: Currency.CU_GBP, label: '£' },
  ]
  const getCurrency = (at: Currency): string => {
    for (let i = 0; i < country.length; i++) {
      if (currency[i].value === at) {
        return currency[i].label
      }
    }
    return t('Base.unknown')
  }

  const getCurrencySymbol = (at: Currency): string => {
    for (let i = 0; i < currencySymbol.length; i++) {
      if (currencySymbol[i].value === at) {
        return currencySymbol[i].label
      }
    }
    return t('Base.unknown')
  }

  const priceingTags = [
    { value: KWHTariffTag.KWHTT_SHARP, label: t('Operation.priceingTariffSharp') },
    { value: KWHTariffTag.KWHTT_PEAK, label: t('Operation.priceingTariffPeak') },
    { value: KWHTariffTag.KWHTT_FLAT, label: t('Operation.priceingTariffFlat') },
    { value: KWHTariffTag.KWHTT_VALLEY, label: t('Operation.priceingTariffValley') },
    { value: KWHTariffTag.KWHTT_DEEP_VALLEY, label: t('Operation.priceingTariffDeepValley') },
  ]
  const getPriceingTagsDesc = (at: number): string => {
    for (let i = 0; i < priceingTags.length; i++) {
      if (priceingTags[i].value === at) {
        return priceingTags[i].label
      }
    }
    return '--'
  }
  const cardTypes = [
    { value: IdType.IT_LOCAL_IDENTITY_CARD, label: t('Operation.localIdentityCard') },
    { value: IdType.IT_ONLINE_IDENTITY_CARD, label: t('Operation.onlineIdentityCard') },
    { value: IdType.IT_LOCAL_WALLET_CARD, label: t('Operation.localWalletCard') },
  ]

  const ticketStates = [
    { value: TicketState.TICS_NEW, label: t('Base.init') },
    { value: TicketState.TICS_PENDING, label: t('Base.pending') },
    { value: TicketState.TICS_PROCESS, label: t('Base.process') },
    { value: TicketState.TICS_HANGUP, label: t('Base.hangup') },
    { value: TicketState.TICS_PROCESSED, label: t('Base.processed') },
    { value: TicketState.TICS_CLOSE, label: t('Base.close') },
  ]

  const languages = [
    { value: Language.L_ZH_CN, label: t('Base.zhch') },
    { value: Language.L_ZH_HANT, label: t('Base.zhhant') },
    { value: Language.L_EN, label: t('Base.en') },
  ]

  const notiChannels = [
    { value: NotiChannel.NC_MAIL, label: t('Operation.email') },
    { value: NotiChannel.NC_SMS, label: t('Operation.sms') },
    { value: NotiChannel.NC_FEI_SHU, label: t('Operation.feishu') },
  ]

  const getNotiChannelDesc = (nc: NotiChannel): string => {
    for (let i = 0; i < notiChannels.length; i++) {
      if (notiChannels[i].value === nc) {
        return notiChannels[i].label
      }
    }
    return t('Base.unknown')
  }

  const paymentChannels = [
    { value: PaymentChannel.PC_ALI_PAY, label: t('Operation.alipay') },
    { value: PaymentChannel.PC_WECHAT_PAY, label: t('Operation.wechat') },
    { value: PaymentChannel.PC_PAYMENT_HUB, label: t('Operation.PC_PAYMENT_HUB') },
    { value: PaymentChannel.PC_HEEPAY, label: t('Operation.PC_HEEPAY') },
    { value: PaymentChannel.PC_YEEPAY, label: t('Operation.yeepay') },
    { value: PaymentChannel.PC_PAYPAL, label: t('Operation.paypal') },
    { value: PaymentChannel.PC_STRIPE, label: t('Operation.PC_STRIPE') },
  ]

  const getPaymentChannelDesc = (nc: PaymentChannel): string => {
    for (let i = 0; i < paymentChannels.length; i++) {
      if (paymentChannels[i].value === nc) {
        return paymentChannels[i].label
      }
    }
    return t('Base.unknown')
  }

  const terminnalChannels = [
    { value: TerminalChannel.TC_APP, label: t('Operation.terminalChannelApp') },
    { value: TerminalChannel.TC_HOME_APP, label: t('Operation.terminalChannelHomeApp') },
    {
      value: TerminalChannel.TC_WECHAT_MINI_APP,
      label: t('Operation.terminalChannelWechatMiniApp'),
    },
    {
      value: TerminalChannel.TC_WECHAT_SERVICE,
      label: t('Operation.terminalChannelWechatService'),
    },
    { value: TerminalChannel.TC_HLHT, label: t('Operation.terminalChannelHlht') },
    { value: TerminalChannel.TC_ALI_MINI_APP, label: t('Operation.terminalChannelAliMiniApp') },
  ]
  const getTerminnalChannelDesc = (nc: TerminalChannel): string => {
    for (let i = 0; i < terminnalChannels.length; i++) {
      if (terminnalChannels[i].value === nc) {
        return terminnalChannels[i].label
      }
    }
    return t('Base.unknown')
  }

  function generateTimeSelect() {
    const timeSelect = []
    const interval = 30 // 30 minutes interval
    const segments = 48 // 48 segments in a day

    for (let i = 0; i <= segments; i++) {
      const totalMinutes = i * interval
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60
      const label = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
      timeSelect.push({ value: i, label: label })
    }

    return timeSelect
  }
  const timeSelect = generateTimeSelect()

  const langOptions = [
    { value: 'en', label: 'English' },
    { value: 'zh_cn', label: '简体中文' },
    { value: 'zhhant', label: '繁體中文' },
    { value: 'he', label: 'עברית' },
    { value: 'de', label: 'Deutsch n' },
    { value: 'es', label: 'español' },
    { value: 'ru', label: 'русский язык' },
    { value: 'vi', label: 'Việt nam' },
  ]

  const getAdoType = (at: ADOType): string => {
    switch (at) {
      case ADOType.ADOT_OPERATOR:
        return t('Operation.operator')
      case ADOType.ADOT_STATION:
        return t('Operation.station')
      case ADOType.ADOT_EVSE:
        return t('Operation.evse')
      case ADOType.ADOT_USER:
        return t('Operation.user')
      case ADOType.ADOT_GROUP:
        return t('Operation.group')
      case ADOType.ADOT_BRAND:
        return t('Operation.brand')
    }
    return t('Base.unknown')
  }

  const adoTypes = [
    { value: ADOType.ADOT_OPERATOR, label: t('Operation.operator') },
    { value: ADOType.ADOT_STATION, label: t('Operation.station') },
    { value: ADOType.ADOT_EVSE, label: t('Operation.evse') },
    { value: ADOType.ADOT_USER, label: t('Operation.user') },
    { value: ADOType.ADOT_GROUP, label: t('Operation.group') },
    { value: ADOType.ADOT_BRAND, label: t('Operation.brand') },
  ]

  const getAdoTypeDesc = (at: number): string => {
    for (let i = 0; i < adoTypes.length; i++) {
      if (adoTypes[i].value === at) {
        return adoTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const getAdoTypeArray = (ats: number[]): enumKeyValueNumberList => {
    const result: enumKeyValueNumberList = []

    for (const num of ats) {
      const foundType = adoTypes.find((type) => type.value === num)
      if (foundType) {
        result.push({ value: foundType.value, label: foundType.label })
      }
      // 如果没找到，可以选择跳过或处理未找到的情况
    }

    return result
  }

  const grainOptions = [
    { value: StatisticsTimeGrain.STD_DAY, label: t('Base.day') },
    { value: StatisticsTimeGrain.STD_MONTH, label: t('Base.month') },
    { value: StatisticsTimeGrain.STD_YEAR, label: t('Base.year') },
  ]

  const chargingScheduleAlgorithms = [
    { value: ChargingScheduleAlgorithm.CSA_DISABLED, label: t('Evses.disableSmartCharging') },
    { value: ChargingScheduleAlgorithm.CAS_AVG, label: t('Evses.smartChargingAVG') },
    // { value: ChargingScheduleAlgorithm.CAS_FCFS,  label: t('Evses.smartChargingFCFS')},
  ]

  const chargingProfilePurposes = [
    { value: 'ChargePointMaxProfile', label: 'ChargePointMaxProfile' },
    { value: 'TxDefaultProfile', label: 'TxDefaultProfile' },
    { value: 'TxProfile', label: 'TxProfile' },
  ]

  const chargingProfileKinds = [
    { value: 'Absolute', label: 'Absolute' },
    { value: 'Recurring', label: 'Recurring' },
    { value: 'Relative', label: 'Relative' },
  ]

  const recurrencyKinds = [
    { value: 'Daily', label: 'Daily' },
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Monthly', label: 'Monthly' },
  ]

  const getChargingScheduleDesc = (at: ChargingScheduleAlgorithm): string => {
    switch (at) {
      case ChargingScheduleAlgorithm.CSA_DISABLED:
        return t('Evses.disableSmartCharging')
      case ChargingScheduleAlgorithm.CAS_AVG:
        return t('Evses.smartChargingAVG')
      case ChargingScheduleAlgorithm.CAS_FCFS:
        return t('Evses.smartChargingFCFS')
    }
    return t('Base.unknown')
  }

  const activityTypes = [
    { value: ActivityType.AT_RECHARGER_GIFT, label: t('Operation.activityRechargerGift') },
    { value: ActivityType.AT_FULL_DISCOUNT, label: t('Operation.activityFullDiscount') },
    { value: ActivityType.AT_REBATE_DISCOUNT, label: t('Operation.activityRebateDiscount') },
  ]

  const getActivityTypeDesc = (at: number): string => {
    for (let i = 0; i < activityTypes.length; i++) {
      if (activityTypes[i].value === at) {
        return activityTypes[i].label
      }
    }
    return t('Base.unknown')
  }
  const evseProtocols = [
    { value: EvseProtocolVendor.EPV_BLUETOOTH, label: t('Evses.homeProto') },
    { value: EvseProtocolVendor.EPV_OCPP, label: t('Evses.ocpp') },
    { value: EvseProtocolVendor.EPV_YKC, label: t('Evses.ykc') },
    { value: EvseProtocolVendor.EPV_HKC, label: t('Evses.hkc') },
    { value: EvseProtocolVendor.EPV_GOIOT, label: t('Evses.goiot') },
    { value: EvseProtocolVendor.EPV_SINEXCEL, label: t('Evses.sinexcel') },
    { value: EvseProtocolVendor.EPV_SZUNIT, label: t('Evses.szunit') },
    { value: EvseProtocolVendor.EPV_CD, label: t('Evses.EPV_CD') },
    { value: EvseProtocolVendor.EPV_QINGAN, label: t('Evses.EPV_QINGAN') },
    { value: EvseProtocolVendor.EPV_SUNGROW, label: t('Evses.EPV_SUNGROW') },
  ]

  const getEvseProtocolDesc = (at: number): string => {
    for (let i = 0; i < evseProtocols.length; i++) {
      if (evseProtocols[i].value === at) {
        return evseProtocols[i].label
      }
    }
    return t('Base.unknown')
  }
  const alarmTypes = [
    { value: AlarmType.AT_INTERVAL, label: t('Evses.alarmTypeInterval') },
    { value: AlarmType.AT_BURST, label: t('Evses.alarmTypeBurst') },
    { value: AlarmType.AT_GRADUAL, label: t('Evses.alarmTypeGradual') },
    { value: AlarmType.AT_COMPONENT, label: t('Evses.alarmTypeComponent') },
  ]
  const getAlarmTypeDesc = (at: number): string => {
    for (let i = 0; i < alarmTypes.length; i++) {
      if (alarmTypes[i].value === at) {
        return alarmTypes[i].label
      }
    }
    return t('Base.unknown')
  }
  const alarmLevels = [
    { value: AlarmLevelType.FN_COMMON, label: t('Evses.alarmLevelCommon') },
    { value: AlarmLevelType.FN_MINOR, label: t('Evses.alarmLevelMinor') },
    { value: AlarmLevelType.FN_IMPORTANT, label: t('Evses.alarmLevelImportant') },
    { value: AlarmLevelType.FN_CRASH, label: t('Evses.alarmLevelCrash') },
  ]
  const getAlarmLevelDesc = (at: number): string => {
    for (let i = 0; i < alarmLevels.length; i++) {
      if (alarmLevels[i].value === at) {
        return alarmLevels[i].label
      }
    }
    return t('Base.unknown')
  }

  const terminalHomeShowTypes = [
    { value: TerminalHomeShowType.THST_LIST, label: t('Base.list') },
    { value: TerminalHomeShowType.THST_MAP, label: t('Base.map') },
  ]
  const getTerminalHomeShowTypeDesc = (at: number): string => {
    for (let i = 0; i < terminalHomeShowTypes.length; i++) {
      if (terminalHomeShowTypes[i].value === at) {
        return terminalHomeShowTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const payeeTypes = [
    { value: ProfitSharingAccountType.PSAT_ENTERPRISE, label: t('Operation.enterprise') },
    { value: ProfitSharingAccountType.PSAT_PRIVATE, label: t('Operation.private') },
    {
      value: ProfitSharingAccountType.PSAT_PRIVATE_ENTERPRISE,
      label: t('Operation.privateEnterprise'),
    },
  ]
  const getPayeeTypeDesc = (at: number): string => {
    for (let i = 0; i < payeeTypes.length; i++) {
      if (payeeTypes[i].value === at) {
        return payeeTypes[i].label
      }
    }
    return t('Base.unknown')
  }
  const bankCardTypes = [
    { value: BankCardType.BCT_DEBIT_CARD, label: t('Operation.debitCard') },
    { value: BankCardType.BCT_CREDIT_CARD, label: t('Operation.creditCard') },
    { value: BankCardType.BCT_QUASI_CREDIT_CARD, label: t('Operation.quasiCreditCard') },
    { value: BankCardType.BCT_PASSBOOK, label: t('Operation.passbook') },
    { value: BankCardType.BCT_UNIT_SETTLE_CARD, label: t('Operation.unitSettleCard') },
    { value: BankCardType.BCT_PUBLIC_CARD, label: t('Operation.publicCard') },
  ]
  const getBankCardTypeDesc = (at: number): string => {
    for (let i = 0; i < payeeTypes.length; i++) {
      if (payeeTypes[i].value === at) {
        return payeeTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const profitSharingSources = [
    { value: ProfitSharingSource.PSS_ELECTRIC_AMOUNT, label: t('Operation.electricAmount') },
    { value: ProfitSharingSource.PSS_SERVICE_AMOUNT, label: t('Operation.serviceAmount') },
    { value: ProfitSharingSource.PSS_TOTAL_AMOUNT, label: t('Operation.totalAmount') },
  ]

  const getProfitSharingSourceDesc = (at: number): string => {
    for (let i = 0; i < profitSharingSources.length; i++) {
      if (profitSharingSources[i].value === at) {
        return profitSharingSources[i].label
      }
    }
    return t('Base.unknown')
  }

  const stationTags = [
    { value: StationTag.ST_GroundParking, label: t('Operation.groundParking') },
    { value: StationTag.ST_UnderGroundParking, label: t('Operation.underGroundParking') },
    { value: StationTag.ST_FreeParking, label: t('Operation.freeParking') },
    { value: StationTag.ST_FreeParkingTimeLimit, label: t('Operation.freeParkingTimeLimit') },
  ]

  const getStationTagDesc = (at: number): string => {
    for (let i = 0; i < stationTags.length; i++) {
      if (stationTags[i].value === at) {
        return stationTags[i].label
      }
    }
    return t('Base.unknown')
  }

  const paymentModeTypes = [
    { value: PaymentModeType.PMT_WALLET, label: t('Operation.walletPayment') },
    { value: PaymentModeType.PMT_ONLINE, label: t('Operation.onlinePayment') },
  ]

  const getPaymentModeTypeDesc = (at: number): string => {
    for (let i = 0; i < paymentModeTypes.length; i++) {
      if (paymentModeTypes[i].value === at) {
        return paymentModeTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const barrierGateCouponTypes = [
    { value: BarrierGateCouponType.HEJT_AMOUNT, label: t('Operation.barrierGateCouponTypeAmount') },
    { value: BarrierGateCouponType.HEJT_TIME, label: t('Operation.barrierGateCouponTypeTime') },
    { value: BarrierGateCouponType.HEJT_FREE, label: t('Operation.barrierGateCouponTypeFree') },
  ]

  const getBarrierGateCouponTypeDesc = (at: number): string => {
    for (let i = 0; i < barrierGateCouponTypes.length; i++) {
      if (barrierGateCouponTypes[i].value === at) {
        return barrierGateCouponTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const profitSharingTransactionTypes = [
    { value: ProfitSharingTransactionType.PSTT_PROFIT_SHARING, label: t('Order.profitSharing') },
    { value: ProfitSharingTransactionType.PSTT_WITHDRAW, label: t('Order.withdraw') },
    {
      value: ProfitSharingTransactionType.PSTT_WITHDRAW_REVOCATION,
      label: t('Order.withdrawRevocation'),
    },
    { value: ProfitSharingTransactionType.PSTT_TRADE_FEE, label: t('Order.tradeFee') },
    { value: ProfitSharingTransactionType.PSTT_WITHDRAW_FEE, label: t('Order.withdrawFee') },
    { value: ProfitSharingTransactionType.PSTT_WALLET_TRANSFER, label: t('Order.walletTransfer') },
    {
      value: ProfitSharingTransactionType.PSTT_PROFIT_SHARING_REVOCATION,
      label: t('Order.profitSharingRevocation'),
    },
  ]

  const getProfitSharingTransactionTypeDesc = (at: number): string => {
    for (let i = 0; i < profitSharingTransactionTypes.length; i++) {
      if (profitSharingTransactionTypes[i].value === at) {
        return profitSharingTransactionTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const profitSharingTradeStates = [
    {
      value: ProfitSharingTradeState.PSTS_NOT_RECORDED,
      label: t('Order.profitSharingTradeStateNotRecorded'),
    },
    { value: ProfitSharingTradeState.PSTS_FAIL, label: t('Order.profitSharingTradeStateFail') },
    { value: ProfitSharingTradeState.PSTS_CLOSE, label: t('Order.profitSharingTradeStateClose') },
    {
      value: ProfitSharingTradeState.PSTS_FUNDS_RECORDED,
      label: t('Order.profitSharingTradeStateFundsRecorded'),
    },
  ]

  const getProfitSharingTradeStateDesc = (at: number): string => {
    for (let i = 0; i < profitSharingTradeStates.length; i++) {
      if (profitSharingTradeStates[i].value === at) {
        return profitSharingTradeStates[i].label
      }
    }
    return t('Base.unknown')
  }

  const auditStates = [
    { value: AuditState.CAS_INIT, label: t('Order.auditStateInit') },
    { value: AuditState.CAS_REJECTED, label: t('Order.auditStateRejected') },
    { value: AuditState.CAS_ACCEPTED, label: t('Order.auditStateAccepted') },
  ]

  const getAuditStateDesc = (at: number): string => {
    for (let i = 0; i < auditStates.length; i++) {
      if (auditStates[i].value === at) {
        return auditStates[i].label
      }
    }
    return t('Base.unknown')
  }
  const transactionStates = [
    { value: TransactionState.TS_INIT, label: t('Order.transactionStateInit') },
    { value: TransactionState.TS_PENDING, label: t('Order.transactionStatePending') },
    { value: TransactionState.TS_HANGUP, label: t('Order.transactionStateHangup') },
    { value: TransactionState.TS_PROCESSING, label: t('Order.transactionStateProcessing') },
    { value: TransactionState.TS_FAIL, label: t('Order.transactionStateFail') },
    { value: TransactionState.TS_CLOSE, label: t('Order.transactionStateClose') },
    { value: TransactionState.TS_SUCCESS, label: t('Order.transactionStateSuccess') },
  ]

  const getTransactionStateDesc = (at: number): string => {
    for (let i = 0; i < transactionStates.length; i++) {
      if (transactionStates[i].value === at) {
        return transactionStates[i].label
      }
    }
    return t('Base.unknown')
  }

  const orderStates = [
    { value: OrderState.OS_INIT, label: t('Order.orderInit') },
    { value: OrderState.OS_WAIT, label: t('Order.orderWait') },
    { value: OrderState.OS_PROCESS, label: t('Order.orderProcess') },
    { value: OrderState.OS_ABNORMAL, label: t('Order.orderAbnormal') },
    { value: OrderState.OS_CLOSE, label: t('Order.orderClose') },
    { value: OrderState.OS_FINISH, label: t('Order.orderFinish') },
  ]

  const getOrderStateDesc = (at: number): string => {
    for (let i = 0; i < orderStates.length; i++) {
      if (orderStates[i].value === at) {
        return orderStates[i].label
      }
    }
    return t('Base.unknown')
  }

  const transactionTypes = [
    { value: TransactionType.TS_PAY, label: t('Order.pay') },
    { value: TransactionType.TS_REFUND, label: t('Order.refund') },
    { value: TransactionType.TS_RECHARGE, label: t('Order.recharge') },
    { value: TransactionType.TS_WITHHOLD, label: t('Order.withhole') },
  ]

  const getTransactionTypeDesc = (at: number): string => {
    // 遍历 transactionTypes 数组
    for (let i = 0; i < transactionTypes.length; i++) {
      if (transactionTypes[i].value === at) {
        return transactionTypes[i].label
      }
    }
    return t('Base.unknown')
  }

  const paymentMethods = [
    { value: PaymentMethod.PM_PREPAYMENT, label: t('Order.prepayment') },
    { value: PaymentMethod.PM_POSTPAYMENT, label: t('Order.postpayment') },
    { value: PaymentMethod.PM_FREE, label: t('Order.free') },
  ]

  const getPaymentMethodDesc = (at: number): string => {
    for (let i = 0; i < paymentMethods.length; i++) {
      if (paymentMethods[i].value === at) {
        return paymentMethods[i].label
      }
    }
    return t('Base.unknown')
  }

  const paymentModes = [
    { value: PaymentMode.PM_WECHAT_PAY, label: t('Order.wechatPay') },
    { value: PaymentMode.PM_ALI_PAY, label: t('Order.aliPay') },
    { value: PaymentMode.PM_GROUP, label: t('Order.group') },
    { value: PaymentMode.PM_IDCARD, label: t('Order.idcard') },
    { value: PaymentMode.PM_WALLET_CARD, label: t('Order.walletCard') },
    { value: PaymentMode.PM_USER_BALANCE, label: t('Order.userBalance') },
    { value: PaymentMode.PM_MANUL, label: t('Order.manul') },
    { value: PaymentMode.PM_VIN, label: t('Order.vin') },
    { value: PaymentMode.PM_PAYPAL, label: t('Order.paypal') },
    { value: PaymentMode.PM_STRIPE, label: t('Order.stripe') },
    { value: PaymentMode.PM_FREE, label: t('Order.free') },
    { value: PaymentMode.PM_TP, label: t('Order.tppay') },
  ]

  const getPaymentModeDesc = (at: number): string => {
    for (let i = 0; i < paymentModes.length; i++) {
      if (paymentModes[i].value === at) {
        return paymentModes[i].label
      }
    }
    return t('Base.unknown')
  }
  const SMSProviders = [
    { value: SMSProvider.SMSP_ALI, label: t('Operation.aliProviderISO') },
    { value: SMSProvider.SMSP_WX, label: t('Operation.wxProvider') },
  ]

  const getSMSProviderDesc = (at: number): string => {
    for (let i = 0; i < SMSProviders.length; i++) {
      if (SMSProviders[i].value === at) {
        return SMSProviders[i].label
      }
    }
    return t('Base.unknown')
  }

  const HLHTProtocols = [
    { value: HLHTProtocol.HP_LTY_OPEN, label: t('Operation.ltyOpen'),} /** HP_HLHT - 互联互通-标准 */,
    { value: HLHTProtocol.HP_HLHT, label: t('Operation.hlht') } /** HP_HLHT - 互联互通-标准 */,
    // { value: HLHTProtocol.HP_HLHTSZ, label: t('Operation.hlhtsz')} /** HP_HLHTSZ - 互联互通-深圳 */,
    // { value: HLHTProtocol.HP_HLHTJX, label: t('Operation.hlhtjx')} /** HP_HLHTJX - 互联互通-江西监控 */,
    { value: HLHTProtocol.HP_AMAP, label: t('Operation.amap') } /** HP_AMAP - 互联互通-高德 */,
    // { value: HLHTProtocol.HP_HLHTSH, label: t('Operation.hlhtsh')} /** HP_HLHTSH - 互联互通-上海监控(国网) */,
    { value: HLHTProtocol.HP_ALI, label: t('Operation.ali') } /** HP_ALI - 互联互通-支付宝 */,
    { value: HLHTProtocol.HP_JSOPEN, label: t('Operation.jsopen') } /** HP_JSOPEN - 捷顺道闸沟通 */,
    { value: HLHTProtocol.HP_BGC, label: t('Operation.bgc') } /** HP_BGC - 八桂充 */,
    { value: HLHTProtocol.HP_NMG, label: t('Operation.nmg') } /** HP_NMG - 内蒙古 */,
    { value: HLHTProtocol.HP_XDT, label: t('Operation.xdt') } /** HP_XDT - 新电途 */,
    { value: HLHTProtocol.HP_ALIHOME, label: t('Operation.alihome'),} /** HP_ALIHOME - 阿里云家充 */,
    { value: HLHTProtocol.HP_ALIHLHT, label: t('Operation.alihlht'),} /** HP_ALIHLHT - 阿里云目的地 */,
  ]

  const getHLHTProtocolDesc = (at: number): string => {
    for (let i = 0; i < HLHTProtocols.length; i++) {
      if (HLHTProtocols[i].value === at) {
        return HLHTProtocols[i].label
      }
    }
    return t('Base.unknown')
  }

  const rescueOrderState = [
    { value: RescueOrderState.ROS_Unknown, label: t('Base.unknown') },
    { value: RescueOrderState.ROS_WaitPay, label: t('Operation.rescueOrderStateWaitPay') },
    { value: RescueOrderState.ROS_Pending, label: t('Operation.rescueOrderStatePending') },
    { value: RescueOrderState.ROS_Processing, label: t('Operation.rescueOrderStateProcessing') },
    { value: RescueOrderState.ROS_Done, label: t('Operation.rescueOrderStateDone') },
    { value: RescueOrderState.ROS_Fail, label: t('Operation.rescueOrderStateFail') },
    { value: RescueOrderState.ROS_Refund, label: t('Operation.rescueOrderStateRefund') },
  ]
  const GetRescueOrderStateDesc = (at: number): string => {
    for (let i = 0; i < rescueOrderState.length; i++) {
      if (rescueOrderState[i].value === at) {
        return rescueOrderState[i].label
      }
    }
    return t('Base.unknown')
  }
  const rescueType = [
    { value: RescueType.RT_Unknown, label: t('Base.unknown') },
    { value: RescueType.RT_JumpStart, label: t('Operation.rescueTypeJumpStart') },
    { value: RescueType.RT_TireChange, label: t('Operation.rescueTypeTireChange') },
    { value: RescueType.RT_Towing, label: t('Operation.rescueTypeTowing') },
    {
      value: RescueType.RT_EmergencyExtraction,
      label: t('Operation.rescueTypeEmergencyExtraction'),
    },
    {
      value: RescueType.RT_DeliveryElectricity,
      label: t('Operation.rescueTypeDeliveryElectricity'),
    },
  ]

  const GetRescueTypeDesc = (at: number): string => {
    for (let i = 0; i < rescueType.length; i++) {
      if (rescueType[i].value === at) {
        return rescueType[i].label
      }
    }
    return t('Base.unknown')
  }
  const CooperStates = [
    { value: CooperState.CS_Unknown, label: t('Base.unknown') },
    { value: CooperState.CS_Pending, label: t('Base.commonStatePending') },
    { value: CooperState.CS_Done, label: t('Base.done') },
  ]

  const GetCooperStateDesc = (at: number): string => {
    for (let i = 0; i < CooperStates.length; i++) {
      if (CooperStates[i].value === at) {
        return CooperStates[i].label
      }
    }
    return t('Base.unknown')
  }

  const CooperTypes = [
    { value: CooperType.CT_Unknown, label: t('Base.unknown') },
    { value: CooperType.CT_Investment, label: t('Operation.investment') },
    { value: CooperType.CT_Cooperation, label: t('Operation.cooperation') },
    { value: CooperType.CT_ToJoin, label: t('Operation.toJoin') },
  ]

  const GetCooperTypeDesc = (at: number): string => {
    for (let i = 0; i < CooperTypes.length; i++) {
      if (CooperTypes[i].value === at) {
        return CooperTypes[i].label
      }
    }
    return t('Base.unknown')
  }
  return {
    essDeviceType,
    enableSelects,
    evseStateSelects,
    connectorStateSelects,
    evseOperationTypes,
    useVehicleTypes,
    evseCurrentTypes,
    evseNetworkingModes,
    evseStandards,
    evsePhases,
    connectorTypes,
    evseFuncs,
    timeRanges,
    country,
    stationType,
    stationConstruction,
    priceingTags,
    getPriceingTagsDesc,
    timeSelect,
    cardTypes,
    ticketStates,
    languages,
    langOptions,
    getAdoType,
    adoTypes,
    getAdoTypeDesc,
    getAdoTypeArray,
    getChargingScheduleDesc,
    grainOptions,
    chargingScheduleAlgorithms,
    chargingProfilePurposes,
    chargingProfileKinds,
    recurrencyKinds,
    currency,
    currencySymbol,
    getCountry,
    getStationType,
    getCurrency,
    getCurrencySymbol,
    notiChannels,
    getNotiChannelDesc,
    paymentChannels,
    getPaymentChannelDesc,
    terminnalChannels,
    getTerminnalChannelDesc,
    activityTypes,
    getActivityTypeDesc,
    evseProtocols,
    getEvseProtocolDesc,
    alarmTypes,
    getAlarmTypeDesc,
    alarmLevels,
    getAlarmLevelDesc,
    terminalHomeShowTypes,
    getTerminalHomeShowTypeDesc,
    payeeTypes,
    getPayeeTypeDesc,
    bankCardTypes,
    getBankCardTypeDesc,
    profitSharingSources,
    getProfitSharingSourceDesc,
    stationTags,
    getStationTagDesc,
    paymentModeTypes,
    getPaymentModeTypeDesc,
    barrierGateCouponTypes,
    getBarrierGateCouponTypeDesc,
    profitSharingTransactionTypes,
    getProfitSharingTransactionTypeDesc,
    profitSharingTradeStates,
    getProfitSharingTradeStateDesc,
    auditStates,
    getAuditStateDesc,
    transactionStates,
    getTransactionStateDesc,
    orderStates,
    getOrderStateDesc,
    transactionTypes,
    getTransactionTypeDesc,
    paymentMethods,
    getPaymentMethodDesc,
    paymentModes,
    getPaymentModeDesc,
    SMSProviders,
    getSMSProviderDesc,
    HLHTProtocols,
    getHLHTProtocolDesc,
    StationStates,
    GroupTypes,
    getGroupTypeDesc,
    PricingDescountInfoTypes,
    getPricingDescountInfoTypeDesc,
    commonStates,
    getCommonStateDesc,
    invoiceTitleTypes,
    getInvoiceTitleTypeDesc,
    BusinessStatesTypes,
    getBusinessStatesTypeDesc,
    defaultRoleTypes,
    BarrierGateTypes,
    getBarrierGateTypeDesc,
    essGridType,
    evseChargingSpeedType,
    rescueOrderState,
    GetRescueOrderStateDesc,
    rescueType,
    GetRescueTypeDesc,
    CooperStates,
    GetCooperStateDesc,
    CooperTypes,
    GetCooperTypeDesc,
  }
}
